module.exports = __webpack_public_path__ + "static/media/facebook-f.263497af.svg";